import { Logger as CloudWatchLogger } from "aws-cloudwatch-log-browser";
import { LOCALSTORAGEKEY } from "../Helper/localStorageUtils";
import { C2CConsole } from "./C2CConsole";

function getUserId() {
  if (localStorage.getItem("user_type") === "staff") {
    return localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  } else {
    return localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  }
}

class C2CLogger {
  //   constructor(cloudWatchClient) {}

  // initializing cloudwatch client
  initializeCloudWatchClient() {
    try {
      if (!this.cloudWatchClient) {
        const config = {
          logGroupName: "frontend-c24-logs",
          logStreamName: "frontend_c24_" + process.env.REACT_APP_ENV + "_logs",
          region: "ap-south-1",
          accessKeyId: process.env.REACT_APP_ACCESS_KEY,
          secretAccessKey: process.env.REACT_APP_SECRET_KEY,
          uploadFreq: 100,
          local: false,
        };
        this.cloudWatchClient = new CloudWatchLogger(config);
      }
    } catch (err) {
      C2CConsole.log("CloudWatch has already been initialized.");
    }
  }

  isCloudWatchClientInitialized() {
    let isInitialized = true;
    if (!this.cloudWatchClient) {
      isInitialized = false;
    }
    return isInitialized;
  }

  error(message) {
    if (!this.isCloudWatchClientInitialized()) {
      // throw Error
      throw new Error("CloudWatch Client is not initialized.");
    }
    // this.cloudWatchClient.log()
    this.onLog({ message: message }, { type: "ERROR" });
  }

  warn(message) {
    if (!this.isCloudWatchClientInitialized()) {
      // throw Error
      throw new Error("CloudWatch Client is not initialized.");
    }
    this.onLog({ message: message }, { type: "WARNING" });
  }

  info(message) {
    if (!this.isCloudWatchClientInitialized()) {
      // throw Error
      throw new Error("CloudWatch Client is not initialized.");
    }

    this.onLog({ message: message }, { type: "INFO" });
  }

  onLog(e, info = {}) {
    if (!this.isCloudWatchClientInitialized()) {
      // throw Error
      throw new Error("CloudWatch Client is not initialized.");
    }
    const messageType = info.type ? info.type : "ERROR";
    // write cloudwatch logging part here.

    this.cloudWatchClient.log({
      source: "WebUI",
      message: {
        [messageType?.toLowerCase()]: e.message,
        // exception: e.stack,
        currentLocation: window.location.href,
      },
      message_type: messageType,
      user_agent: window.navigator.userAgent,
      user_type: 1,
      user_id: getUserId(),
      function_name: null,
    });
  }
}

export default C2CLogger;
